import React from 'react';
import './section-tabs.scss';

const SectionTabs = ({ tabs = [], activeTab, onTabClick, className = '' }) => {
  if (!tabs.length) {
    return null;
  }

  return (
    <div className={`section-tabs ${className}`.trim()}>
      <ul>
        {tabs.map((tab) => (
          <li key={tab.id} className={activeTab === tab.id ? 'active' : ''}>
            <button type="button" onClick={() => onTabClick(tab.id)}>
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SectionTabs;
